import {Component, EventEmitter} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DocumentsApiService, FileDataResponse} from '../../../services/api/documents-api.service';

@Component({
    selector: 'app-document-detail',
    templateUrl: './document-detail.component.html',
    styleUrls: ['./document-detail.component.scss']
})
export class DocumentDetailComponent {
    public fileKey: string = null;
    public versionKey: string = null;
    public documentData: FileDataResponse;

    emitRefresh: EventEmitter<any> = new EventEmitter<any>();
    emitRefreshApproved: EventEmitter<any> = new EventEmitter<any>();

    tab: 'view' | 'edit' | 'access' = 'view';
    showTabs = false;
    isPermissionsChanged = false;

    constructor(
        protected documentApi: DocumentsApiService,
        protected activeRoute: ActivatedRoute,
        protected router: Router
    ) {
        this.router.events.subscribe(event => {
            this.onLoading();
        });
    }

    onLoading(): void {
        this.activeRoute.params.subscribe((param: any) => {
            this.documentApi.getFileData(param.file).subscribe(res => {
                this.documentData = res;
                this.fileKey = param.file;
                this.versionKey = param.version;
                this.showTabs = true;
            });
        });
    }

    onLoadData(doc: FileDataResponse): void {
        this.documentData = doc;
    }
}
